<template>
    <Fieldset>
        <template #legend>
            <h3 class="text-lg font-semibold">{{ $t('Payment method') }}</h3>
        </template>

        <Field :error="form.errors.payment_method_id" class="md:col-span-2" v-slot="{ hasError, errorId }">
            <RadioButtonGroup name="payment_method" v-model="form.payment_method_id" class="border border-slate-200 rounded-xl divide-y divide-slate-200">
                <template v-for="option in paymentMethods" :key="option.id">
                    <RadioButton :value="option.id" class="px-4 py-3">
                        <span class="text-slate-700" v-html="option.name" />
                    </RadioButton>
                </template>
            </RadioButtonGroup>
        </Field>
    </Fieldset>
</template>

<script setup>
defineProps({
    form: {
        type: Object,
        required: true
    },
    paymentMethods: {
        type: Array,
        required: true
    }
})
</script>
